import React from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import { useAuth } from '~/hooks';
import { ErrorPage } from '~/routes/public/pages';
import AllocationsListPage from './allocations/list';
import MemberSchedule from './allocations/member-schedule/MemberSchedule';
import ProjectSchedule from './allocations/project-schedule/ProjectSchedule';

export default function ResourcesArea({ children }) {
  const { path, url } = useRouteMatch();

  const auth = useAuth();

  return (
    children || (
      <Switch>
        <Route path={`${path}/schedule/members`}>
          {auth.allocations.members.view ? <MemberSchedule /> : <ErrorPage.Forbidden publicSite={false} />}
        </Route>
        <Route path={`${path}/schedule/projects`}>
          {auth.allocations.projects.view ? <ProjectSchedule /> : <ErrorPage.Forbidden publicSite={false} />}
        </Route>

        {/* Preserve existing schedule bookmarks (including nested /edit, /view, /new links) after renaming the route to /schedule */}
        <Route
          path={[`${path}/allocations/members`, `${path}/allocations/projects`]}
          render={({ location }) => (
            <Redirect
              to={{ ...location, pathname: location.pathname.replace(`${url}/allocations/`, `${url}/schedule/`) }}
            />
          )}
        />

        <Route path={`${path}/allocations`}>
          {auth.allocations.view ? <AllocationsListPage /> : <ErrorPage.Forbidden publicSite={false} />}
        </Route>

        <Redirect
          path="/"
          to={auth.allocations.members.view ? `${url}/schedule/members` : `${url}/schedule/projects`}
        />
      </Switch>
    )
  );
}
